// src/components/common/ErrorFeedbackModal.js
import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import { axiosInstance } from '../../axios';

Modal.setAppElement('#root');

const ErrorFeedbackModal = ({ isOpen, onClose, error, userId }) => {
  const [whatHappened, setWhatHappened] = useState('');
  const [whatShouldHaveHappened, setWhatShouldHaveHappened] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const closeTimer = useRef(null);
  useEffect(() => () => clearTimeout(closeTimer.current), [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const feedbackData = {
      userId: userId,
      errorMessage: error.message,
      errorStack: error.stack,
      whatHappened: whatHappened,
      whatShouldHaveHappened: whatShouldHaveHappened,
      url: window.location.href,
    };

    try {
      await axiosInstance.post('feedback/submit-error/', feedbackData);
      setSubmissionStatus('success');
      closeTimer.current = setTimeout(() => {
        onClose();
      }, 2000);
    } catch (err) {
      console.error('Failed to submit feedback:', err);
      setSubmissionStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: 1000
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: '500px',
          padding: '2rem',
          borderRadius: '14px',
          border: '1px solid #ccc'
        }
      }}
      contentLabel="Error Feedback Modal"
    >
      <h2>Oh no! Something went wrong. 😟</h2>
      <p style={{ lineHeight: '1.6', color: '#555' }}>
        We're so sorry for the hiccup! Pricing Penguin is a brand new business, built by a very small team of two people. We're working hard to make things perfect, but sometimes things go a little sideways.
      </p>
      <p style={{ lineHeight: '1.6', color: '#555' }}>
        Your feedback is incredibly valuable to us. By telling us what happened, you're helping us find and fix these issues faster. Thank you for being a part of our journey!
      </p>

      {submissionStatus === 'success' ? (
        <div style={{ textAlign: 'center', color: 'green', marginTop: '1rem' }}>
          <h3>Thank you! Your feedback has been sent.</h3>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label htmlFor="whatHappened">What were you trying to do?</label>
            <textarea
              id="whatHappened"
              value={whatHappened}
              onChange={(e) => setWhatHappened(e.target.value)}
              required
              style={{ width: '100%', minHeight: '80px', marginTop: '0.5rem', padding: '8px' }}
            />
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label htmlFor="whatShouldHaveHappened">What did you expect to happen?</label>
            <textarea
              id="whatShouldHaveHappened"
              value={whatShouldHaveHappened}
              onChange={(e) => setWhatShouldHaveHappened(e.target.value)}
              required
              style={{ width: '100%', minHeight: '80px', marginTop: '0.5rem', padding: '8px' }}
            />
          </div>
          <p style={{ fontSize: '0.8rem', color: '#777', marginTop: '1rem' }}>
            <strong>Technical details that will be sent:</strong> {error.message}
          </p>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '1.5rem' }}>
            <button type="button" onClick={onClose} style={{ padding: '10px 20px', cursor: 'pointer' }}>
              Close
            </button>
            <button type="submit" disabled={isSubmitting} style={{ padding: '10px 20px', cursor: 'pointer', background: '#3B82F6', color: 'white', border: 'none', borderRadius: '4px' }}>
              {isSubmitting ? 'Sending...' : 'Send Feedback'}
            </button>
          </div>
          {submissionStatus === 'error' && (
            <p style={{ color: 'red', marginTop: '1rem', textAlign: 'center' }}>
              Could not submit feedback. Please try again.
            </p>
          )}
        </form>
      )}
    </Modal>
  );
};

export default ErrorFeedbackModal;
